import { A11yModule } from '@angular/cdk/a11y';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { SelfCheckinComponent } from '../core/self-checkin/self-checkin.component';
import { UserMessageComponent } from './messages/user-message/user-message.component';
import { MessageHostComponent } from './messages/message-host/message-host.component';
import { CheckinAvatarComponent } from './checkin-avatar/checkin-avatar.component';
import { SystemMenuComponent } from './system-menu/system-menu.component';
import { ProfileFieldEditorComponent } from './profile/profile-field-editor.component';
import { ListActionsComponent } from './list-actions/list-actions.component';
import { AddressAutocompleteComponent } from './address-check/address-autocomplete.component';
import { AddressCheckComponent } from './address-check/address-check.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
// import { NgbModule, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { MemberSearchComponent } from './member-search/member-search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ProfileComponent } from './profile/profile/profile.component';
import { OnlyNumber } from './directives/only-numbers.directive';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './reuse/CustomReuseStrategy.service';
import { ValidateDateDirective } from './directives/validateDate.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LayoutModule } from '@angular/cdk/layout';
import { NgxPaginationModule } from 'ngx-pagination';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatSelectModule } from '@angular/material/select';
import { HttpClientModule } from '@angular/common/http';

import {
  DateAdapter,
  MatNativeDateModule,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { EventSearchComponent } from './event-search/event-search.component';
import { ContactComponent } from './contact/contact.component';
import { MemberHeaderComponent } from './member-header/member-header.component';
import { SharedCommunicationComponent } from './shared-communication/shared-communication.component';
//import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import 'froala-editor/js/plugins.pkgd.min.js';
import { CommScopeComponent } from './comm-scope/comm-scope.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { MembersOnMapComponent } from './maps/members-on-map/members-on-map.component';
import { MembersOnClusterComponent } from './maps/members-on-cluster/members-on-cluster.component';
import { UserToolsComponent } from './user-tools/user-tools.component';
import { UserTaskComponent } from './user-task/user-task.component';
import { ConfirmMessageComponent } from './messages/confirm-message/confirm-message.component';
import { PromptMessageComponent } from './messages/prompt-message/prompt-message.component';
import { ChartComponent } from './charts/chart/chart.component';
import { NgChartsModule } from 'ng2-charts';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { PhoneVerifyComponent } from './phone-verify/phone-verify.component';
import { Chart2Component } from './charts/chart2/chart2.component';
import { OnlyDecimal } from './directives/only-decimals.directive';
import { FooterComponent } from '../core/footer/footer.component';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideDirective } from './directives/click-outside.directive';

@NgModule({ declarations: [SelfCheckinComponent, SystemMenuComponent, ListActionsComponent, ProfileFieldEditorComponent,
        LoadingSpinnerComponent,
        AddressCheckComponent,
        AddressAutocompleteComponent,
        MemberSearchComponent,
        ProfileComponent,
        OnlyNumber,
        OnlyDecimal,
        ValidateDateDirective,
        EventSearchComponent,
        ContactComponent,
        MemberHeaderComponent,
        SharedCommunicationComponent,
        CommScopeComponent,
        AttachmentComponent,
        MembersOnMapComponent,
        MembersOnClusterComponent,
        UserToolsComponent,
        UserTaskComponent,
        ConfirmMessageComponent,
        PromptMessageComponent,
        ChartComponent,
        PieChartComponent,
        PhoneVerifyComponent,
        Chart2Component,
        FooterComponent
    ],
    exports: [EmptyStateComponent, SelfCheckinComponent, UserMessageComponent, MessageHostComponent, CheckinAvatarComponent, ListActionsComponent, ProfileFieldEditorComponent,
        LoadingSpinnerComponent,
        AddressCheckComponent,
        AddressAutocompleteComponent,
        CommonModule,
        NgChartsModule,
        // NgbModule,
        // FlexLayoutModule,
        MemberSearchComponent,
        ProfileComponent,
        EventSearchComponent,
        OnlyNumber,
        OnlyDecimal,
        ValidateDateDirective,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        LayoutModule,
        NgxPaginationModule,
        ContactComponent,
        HttpClientModule,
        MemberHeaderComponent,
        SharedCommunicationComponent,
        //Ng2SearchPipeModule,
        // FroalaEditorModule,
        // FroalaViewModule,
        EditorModule,
        MembersOnMapComponent,
        MembersOnClusterComponent,
        UserToolsComponent,
        UserTaskComponent,
        ConfirmMessageComponent,
        PromptMessageComponent,
        ChartComponent,
        Chart2Component,
        PieChartComponent,
        PhoneVerifyComponent,
        FooterComponent,
        ClickOutsideDirective
    ], imports: [EmptyStateComponent, UserMessageComponent, MessageHostComponent, CheckinAvatarComponent, A11yModule, CommonModule,
        // NgbModule,
        // FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatSelectModule,
        MatSlideToggleModule,
        LayoutModule,
        NgxPaginationModule,
        NgbAlertModule,
        ClickOutsideDirective,
        HttpClientModule,
        //Ng2SearchPipeModule,
        EditorModule,
        NgChartsModule], providers: [
        {
            provide: RouteReuseStrategy,
            useClass: CustomReuseStrategy,
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: MomentDateAdapter },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
  provide: TINYMCE_SCRIPT_SRC,
  useValue: 'https://cdn.tiny.cloud/1/p4ups0ehnkfioskf90008v69wieluyp8tvmwwd5rap1ycqsz/tinymce/8/tinymce.min.js'
}
    ] })
export class SharedModule {}
